<template>
	<div class="game-board">
		<template v-if="revealAnswers">
			<div
				:class="animationMap.you"
				class="anwser-container">
				<div class="anwser-container__answer you">
					<div class="img-container">
						<img
							:src="selectedAnswers.you.img"
							:alt="selectedAnswers.you.text" />
					</div>
					<h1 :class="`text-${selectedAnswers.you.color}`">{{ selectedAnswers.you.text }}</h1>
				</div>
			</div>
			<div
				:class="animationMap.computer"
				class="anwser-container">
				<div class="anwser-container__answer computer">
					<div class="img-container">
						<img
							:src="selectedAnswers.computer.img"
							:alt="selectedAnswers.computer.text" />
					</div>
					<h1 :class="`text-${selectedAnswers.computer.color}`">{{ selectedAnswers.computer.text }}</h1>
				</div>
			</div>
		</template>

		<div
			:class="activeBoard"
			class="active-slide" />
	</div>
</template>

<script>
	import Options, { ACTIVE_PLAYER, ANIMATION_ANSWERS, TIE, WINNER } from '@/reference';

	export default {
		name: 'game-board',
		props: {
			activePlayer: { type: String, default: ACTIVE_PLAYER.you.id },
			revealAnswers: { type: Boolean, default: false },
			selectedAnswers: { type: Object },
			winner: { type: [String, Object] },
		},
		computed: {
			activeBoard() {
				return this.activePlayer === ACTIVE_PLAYER.you.id ? 'active-you' : 'active-computer';
			},
			animationMap() {
				const obj = { you: '', computer: '' };

				if (this.winner === TIE) {
					Object.keys(obj).forEach((k) => {
						obj[k] = ANIMATION_ANSWERS[TIE];
					});
				} else if (this.winner !== null) {
					obj[this.winner] = ANIMATION_ANSWERS[WINNER];
				}

				return obj;
			},
		},
		Options,
	};
</script>

<style lang="scss">
	.game-board {
		$mobile-size-game-board: 37.5em; //600px

		@extend %flex-row;
		background-color: color('coral-blush');
		border-radius: 8px;
		box-shadow: 0px 8px 8px rgba(color('black'), 0.1);

		@include responsive($mobile-size-game-board) {
			flex-direction: column;
		}

		&,
		.anwser-container {
			position: relative;
		}

		.anwser-container {
			@extend %layout-flex-center-xy;
			flex: 1;
			z-index: 1;

			&__answer {
				@extend %layout-flex-center-y;
				gap: 8px;
				width: 100%;

				@include responsive($mobile-size-game-board) {
					justify-content: center;
					padding: 8px 16px;
				}

				&.you {
					@include responsive($mobile-size-game-board) {
						flex-direction: row;
					}
				}

				&.computer {
					@include responsive($mobile-size-game-board) {
						flex-direction: row-reverse;
					}
				}

				.img-container {
					@extend %layout-flex-center-xy;
					height: 350px;

					@include responsive(large) {
						height: 300px;
					}

					@include responsive(medium) {
						height: 250px;
						width: 100%;
					}

					@include responsive($mobile-size-game-board) {
						width: unset;
						height: 200px;
					}

					@include responsive(small) {
						height: 150px;
					}

					img {
						height: 100%;

						@include responsive(medium) {
							width: 80%;
							object-fit: contain;
						}
					}
				}

				h1 {
					@include responsive(small) {
						font-size: 40px;
					}
				}
			}
		}

		.active-slide {
			--slide-width: 52%;

			height: 100%;
			width: var(--slide-width);
			background-color: rgba(color('soft-cream'), 0.6);
			border-radius: 8px;
			position: absolute;
			transition: all 0.5s ease-in-out;
			left: 100%;

			@include responsive($mobile-size-game-board) {
				height: var(--slide-width);
				width: 100%;
			}

			&.active-you {
				left: 0;
				box-shadow: 8px 0px 4px rgba(color('black'), 0.1);

				@include responsive($mobile-size-game-board) {
					left: unset;
					top: 0;
					box-shadow: 0px 8px 4px rgba(color('black'), 0.1);
				}
			}

			&.active-computer {
				left: calc(100% - var(--slide-width));
				box-shadow: -8px 0px 4px rgba(color('black'), 0.1);

				@include responsive($mobile-size-game-board) {
					left: unset;
					top: calc(100% - var(--slide-width));
					box-shadow: 0px -8px 4px rgba(color('black'), 0.1);
				}
			}
		}
	}
</style>
